export class AnnualFeeStatsFilteringModel {

  public startFilterDate: Date;
  public endFilterDate: Date;
  public companyId: number;
  public productIds: [];

}
